module.exports = __webpack_public_path__ + "public/img/w2.00322e2a.png";